/**
 * @generated SignedSource<<2d0ee6fe0daa3a72c554f7b0f9348955>>
 * @relayHash bdf3b816161438b9e52d0db41ad73b54
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c26a0822e9d917157513144d6dd817c0be149e4fa8a793cdc98cf8b0bbc52500

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SearchCombinationType = "AND" | "OR" | "%future added value";
export type SearchConfluenceDocumentStatus = "ARCHIVED" | "CURRENT" | "DRAFT" | "%future added value";
export type SearchConfluenceRangeField = "CREATED" | "LASTMODIFIED" | "%future added value";
export type SearchContainerStatus = "ARCHIVED" | "CURRENT" | "%future added value";
export type SearchIssueStatusCategory = "DONE" | "INDETERMINATE" | "NEW" | "OPEN" | "UNDEFINED" | "%future added value";
export type SearchLinkedEntityGranularity = "ALL_MATCHING_MESSAGES" | "DEFAULT" | "FULL_THREAD" | "ONLY_LINKED_ENTITIES" | "%future added value";
export type SearchLoomVideoType = "ASYNC_VIDEO" | "MEETING_RECORDING" | "%future added value";
export type SearchParticipantType = "COMMENTED" | "CONTRIBUTOR" | "MENTIONS" | "PRESENCE" | "SHARED" | "VIEWED" | "%future added value";
export type SearchProjectType = "business" | "customer_service" | "product_discovery" | "service_desk" | "software" | "%future added value";
export type SearchSalesforceAttributeFilterOperator = "BETWEEN" | "EQ" | "GT" | "GTE" | "IN" | "LT" | "LTE" | "%future added value";
export type SearchSalesforceAttributeFilterSource = "CUSTOM_PROPERTIES_DATE" | "CUSTOM_PROPERTIES_KEYWORD" | "CUSTOM_PROPERTIES_NUMBER" | "RELATIONSHIPS" | "%future added value";
export type SearchServiceNowAttributeFilterOperator = "BETWEEN" | "EQ" | "GT" | "GTE" | "IN" | "LT" | "LTE" | "%future added value";
export type SearchServiceNowAttributeFilterSource = "ADD_ON_PROPERTIES_DATE" | "KEYWORD" | "RELATIONSHIPS" | "%future added value";
export type SearchSortOrder = "ASC" | "DESC" | "%future added value";
export type SearchThirdPartyRangeField = "CREATED" | "LASTMODIFIED" | "%future added value";
export type SearchCommonFilter = {
  contributorsFilter?: ReadonlyArray<string> | null;
  participants?: SearchParticipants | null;
  range?: SearchCommonRangeFilter | null;
};
export type SearchParticipants = {
  combination: SearchCombinationType;
  items: ReadonlyArray<SearchParticipant>;
};
export type SearchParticipant = {
  combination: SearchCombinationType;
  type: SearchParticipantType;
  users: ReadonlyArray<string>;
};
export type SearchCommonRangeFilter = {
  created?: SearchCommonRangeFilterFields | null;
  lastModified?: SearchCommonRangeFilterFields | null;
};
export type SearchCommonRangeFilterFields = {
  gt?: string | null;
  lt?: string | null;
};
export type SearchConfluenceFilter = {
  ancestorIdsFilter?: ReadonlyArray<string> | null;
  containerARIs?: ReadonlyArray<string> | null;
  containerStatus?: ReadonlyArray<SearchContainerStatus | null> | null;
  contentStatuses?: ReadonlyArray<SearchConfluenceDocumentStatus> | null;
  contributorsFilter?: ReadonlyArray<string> | null;
  creatorsFilter?: ReadonlyArray<string> | null;
  isVerified?: boolean | null;
  labelsFilter?: ReadonlyArray<string> | null;
  mentions?: ReadonlyArray<string> | null;
  owners?: ReadonlyArray<string> | null;
  pageStatus?: ReadonlyArray<string> | null;
  range?: ReadonlyArray<SearchConfluenceRangeFilter | null> | null;
  spacesFilter?: ReadonlyArray<string> | null;
  titleMatchOnly?: boolean | null;
};
export type SearchConfluenceRangeFilter = {
  field: SearchConfluenceRangeField;
  gt?: string | null;
  lt?: string | null;
};
export type SearchJiraFilter = {
  boardFilter?: SearchBoardFilter | null;
  issueFilter?: SearchJiraIssueFilter | null;
  projectFilter?: SearchJiraProjectFilter | null;
};
export type SearchBoardFilter = {
  negateProjectFilter?: boolean | null;
  projectARI?: string | null;
  userARI?: string | null;
};
export type SearchJiraIssueFilter = {
  assigneeARIs?: ReadonlyArray<string> | null;
  commenterARIs?: ReadonlyArray<string> | null;
  issueLabels?: ReadonlyArray<string> | null;
  issueTypeIDs?: ReadonlyArray<string> | null;
  issueTypes?: ReadonlyArray<string> | null;
  projectARIs?: ReadonlyArray<string> | null;
  reporterARIs?: ReadonlyArray<string> | null;
  statusCategories?: ReadonlyArray<SearchIssueStatusCategory> | null;
  watcherARIs?: ReadonlyArray<string> | null;
};
export type SearchJiraProjectFilter = {
  projectType?: SearchProjectType | null;
  projectTypes?: ReadonlyArray<SearchProjectType> | null;
};
export type SearchLoomFilters = {
  folderIds?: ReadonlyArray<string> | null;
  playlistIds?: ReadonlyArray<string> | null;
  spaceIds?: ReadonlyArray<string> | null;
  tagNames?: ReadonlyArray<string> | null;
  videoTypes?: ReadonlyArray<SearchLoomVideoType> | null;
};
export type SearchAssetsFilter = {
  objectSchemaFilter?: SearchAssetsObjectSchemaFilter | null;
  objectTypeFilter?: SearchAssetsObjectTypeFilter | null;
};
export type SearchAssetsObjectSchemaFilter = {
  schemaARIs?: ReadonlyArray<string> | null;
};
export type SearchAssetsObjectTypeFilter = {
  typeARIs?: ReadonlyArray<string> | null;
};
export type SearchMercuryFilter = {
  ancestorIds?: ReadonlyArray<string> | null;
  focusAreaTypeIds?: ReadonlyArray<string> | null;
  owners?: ReadonlyArray<string> | null;
};
export type SearchTalentFilter = {
  employmentTypes?: ReadonlyArray<string> | null;
  focusAreas?: ReadonlyArray<string> | null;
  jobFamilies?: ReadonlyArray<string> | null;
  owners?: ReadonlyArray<string> | null;
  statuses?: ReadonlyArray<string> | null;
  teams?: ReadonlyArray<string> | null;
};
export type SearchCompassFilter = {
  componentFilter?: SearchCompassComponentFilter | null;
};
export type SearchCompassComponentFilter = {
  componentStates: ReadonlyArray<string>;
};
export type SearchThirdPartyFilter = {
  additionalTexts?: ReadonlyArray<string> | null;
  ancestorAris?: ReadonlyArray<string> | null;
  assignees?: ReadonlyArray<string> | null;
  containerAris?: ReadonlyArray<string> | null;
  containerNames?: ReadonlyArray<string> | null;
  containerTypes?: ReadonlyArray<string> | null;
  createdBy?: ReadonlyArray<string> | null;
  excludeSubtypes?: ReadonlyArray<string> | null;
  gitFilters?: SearchGitFilters | null;
  gongFilters?: SearchGongFilters | null;
  integrations?: ReadonlyArray<string> | null;
  labels?: ReadonlyArray<string> | null;
  lastUpdatedBy?: ReadonlyArray<string> | null;
  range?: ReadonlyArray<SearchThirdPartyRangeFilter | null> | null;
  salesforceFilters?: SearchSalesforceFilters | null;
  serviceNowFilters?: SearchServiceNowFilters | null;
  subtypes?: ReadonlyArray<string | null> | null;
  teamsFilters?: SearchTeamsFilters | null;
  thirdPartyProducts?: ReadonlyArray<SearchThirdPartyProduct> | null;
  thirdPartyTypes?: ReadonlyArray<string> | null;
  titleMatchOnly?: boolean | null;
};
export type SearchGitFilters = {
  pullRequestStatus?: ReadonlyArray<string> | null;
  repoName?: ReadonlyArray<string> | null;
  reviewer?: ReadonlyArray<string> | null;
};
export type SearchGongFilters = {
  crmAccountName?: ReadonlyArray<string> | null;
};
export type SearchThirdPartyRangeFilter = {
  field: SearchThirdPartyRangeField;
  gt?: string | null;
  lt?: string | null;
};
export type SearchSalesforceFilters = {
  attributeFilters?: ReadonlyArray<SearchSalesforceAttributeFilter> | null;
  campaignStatuses?: ReadonlyArray<string> | null;
  caseStatuses?: ReadonlyArray<string> | null;
  closeDate?: string | null;
  eventTypes?: ReadonlyArray<string> | null;
  isClosed?: boolean | null;
  knowledgeArticlePublishStatuses?: ReadonlyArray<string> | null;
  leadStatuses?: ReadonlyArray<string> | null;
  owners?: ReadonlyArray<string> | null;
  stage?: ReadonlyArray<string> | null;
  taskStatuses?: ReadonlyArray<string> | null;
  taskTypes?: ReadonlyArray<string> | null;
};
export type SearchSalesforceAttributeFilter = {
  field: string;
  from?: string | null;
  operator: SearchSalesforceAttributeFilterOperator;
  source: SearchSalesforceAttributeFilterSource;
  to?: string | null;
  value?: string | null;
  values?: ReadonlyArray<string> | null;
};
export type SearchServiceNowFilters = {
  attributeFilters?: ReadonlyArray<SearchServiceNowAttributeFilter> | null;
  owners?: ReadonlyArray<string> | null;
};
export type SearchServiceNowAttributeFilter = {
  field: string;
  from?: string | null;
  operator: SearchServiceNowAttributeFilterOperator;
  source: SearchServiceNowAttributeFilterSource;
  to?: string | null;
  value?: string | null;
  values?: ReadonlyArray<string> | null;
};
export type SearchTeamsFilters = {
  attachmentFileTypes?: ReadonlyArray<string> | null;
  hasAttachment?: boolean | null;
  hasLink?: boolean | null;
  messageType?: string | null;
  workspaceName?: ReadonlyArray<string> | null;
};
export type SearchThirdPartyProduct = {
  channels?: ReadonlyArray<string | null> | null;
  connectionIds?: ReadonlyArray<string> | null;
  connectorSources?: ReadonlyArray<string> | null;
  connectorSourcesImpersonationEnabled?: ReadonlyArray<string> | null;
  containerTypes?: ReadonlyArray<string> | null;
  datasourceId?: string | null;
  entities?: ReadonlyArray<string> | null;
  integrationId?: string | null;
  linkedEntities?: ReadonlyArray<string> | null;
  linkedEntityGranularity?: SearchLinkedEntityGranularity | null;
  product?: string | null;
  providerId?: string | null;
  subtypes?: ReadonlyArray<string> | null;
};
export type SearchSortInput = {
  field: string;
  key?: string | null;
  order: SearchSortOrder;
};
export type SearchExperimentLayer = {
  definitions?: ReadonlyArray<SearchLayerDefinition | null> | null;
  layerId?: string | null;
  name?: string | null;
  shadowId?: string | null;
};
export type SearchLayerDefinition = {
  abTestId?: string | null;
  armId?: string | null;
  connectorSources?: ReadonlyArray<string | null> | null;
  entity?: string | null;
  integrationARI?: string | null;
  layerId?: string | null;
  providerId?: string | null;
  shadowId?: string | null;
  statsigLayerId?: string | null;
  subEntity?: string | null;
};
export type SearchMatchingLayerExperimentsMetadata = {
  matchingLayers?: ReadonlyArray<SearchMatchingLayer | null> | null;
};
export type SearchMatchingLayer = {
  layerName?: string | null;
  layerType?: string | null;
};
export type searchResultsAsyncQuery$variables = {
  after?: string | null;
  assetsFilters?: SearchAssetsFilter | null;
  cloudIdARIs: ReadonlyArray<string>;
  commonFilters?: SearchCommonFilter | null;
  compassFilters?: SearchCompassFilter | null;
  confluenceFilters?: SearchConfluenceFilter | null;
  deferFederatedResults: boolean;
  disableQueryReplacement?: boolean | null;
  enableHighlighting?: boolean | null;
  enableRelevanceDebugging?: boolean | null;
  entities: ReadonlyArray<string>;
  expectResult?: boolean | null;
  experience: string;
  experimentId?: string | null;
  experimentLayers?: ReadonlyArray<SearchExperimentLayer | null> | null;
  fanoutExperimentCohort?: string | null;
  includeCaseEmbeddedComments?: boolean | null;
  includeCodeSearch?: boolean | null;
  includeDatasourceId?: boolean | null;
  includeFastJiraHydration?: boolean | null;
  includeJiraEmbeddedComments?: boolean | null;
  includeJiraLiteModeFields?: boolean | null;
  includeMercuryAsk?: boolean | null;
  includeNavBoostScore?: boolean | null;
  includeOriginalEntityType?: boolean | null;
  includePassionfruitAsk?: boolean | null;
  includePositions?: boolean | null;
  includeRisk?: boolean | null;
  includeThirdPartyId?: boolean | null;
  jiraFilters?: SearchJiraFilter | null;
  limit: number;
  loomFilters?: SearchLoomFilters | null;
  matchingLayerExperimentsMetadata?: SearchMatchingLayerExperimentsMetadata | null;
  mercuryFilters?: SearchMercuryFilter | null;
  query: string;
  queryVersion?: number | null;
  searchSessionId?: string | null;
  sessionId?: string | null;
  shadowExperimentId?: string | null;
  sort?: ReadonlyArray<SearchSortInput | null> | null;
  sourceProduct?: string | null;
  sourceSubProduct?: string | null;
  talentFilters?: SearchTalentFilter | null;
  tenantId: string;
  thirdPartyFilters?: SearchThirdPartyFilter | null;
  useCaseId?: string | null;
};
export type searchResultsAsyncQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"searchResults_AtlassianSearchPage_SearchResultsAsyncInner_queryData">;
};
export type searchResultsAsyncQuery = {
  response: searchResultsAsyncQuery$data;
  variables: searchResultsAsyncQuery$variables;
};
({
  "__relay_internal__pv__isassetsenabledrelayprovider": includeAssets_provider,
  "__relay_internal__pv__isslackworkspacemetadataenabledrelayprovider": includeSlackWorkspaceMetadata_provider,
  "__relay_internal__pv__isleadnounenabledrelayprovider": isLeadNounEnabled_provider,
  "__relay_internal__pv__isleaduserastitleenabledrelayprovider": isLeadUserAsTitleEnabled_provider,
  "__relay_internal__pv__isslacktopreactionenabledrelayprovider": includeSlackTopReaction_provider,
  "__relay_internal__pv__skiplinkeduserhydrationrelayprovider": skipLinkedUserHydration_provider,
  "__relay_internal__pv__isprojectrendererenabledrelayprovider": isProjectRendererEnabled_provider,
  "__relay_internal__pv__ismetadatacontentenabledrelayprovider": includeMetadataContent_provider
} as {
  readonly __relay_internal__pv__isassetsenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__isleadnounenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__isleaduserastitleenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__ismetadatacontentenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__isprojectrendererenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__isslacktopreactionenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__isslackworkspacemetadataenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__skiplinkeduserhydrationrelayprovider: {
    readonly get: () => boolean;
  };
});

import includeAssets_provider from './../is-assets-enabled.relayprovider';
import skipLinkedUserHydration_provider from './../search-result/search-result-renderer/common/thread-body/thread-message/skip-linked-user-hydration.relayprovider';
import isLeadNounEnabled_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-lead/is-lead-noun-enabled.relayprovider';
import isLeadUserAsTitleEnabled_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-lead/is-lead-user-as-title-enabled.relayprovider';
import includeSlackWorkspaceMetadata_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-message/../is-slack-workspace-metadata-enabled.relayprovider';
import includeSlackTopReaction_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-message/is-slack-top-reaction-enabled.relayprovider';
import isProjectRendererEnabled_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-project/is-project-renderer-enabled.relayprovider';
import includeMetadataContent_provider from './../search-result/search-result-renderer/search-graph-result/search-graph-video/is-metadata-content-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assetsFilters"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudIdARIs"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commonFilters"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "compassFilters"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "confluenceFilters"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "deferFederatedResults"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "disableQueryReplacement"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "enableHighlighting"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "enableRelevanceDebugging"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entities"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "expectResult"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experience"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experimentId"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experimentLayers"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fanoutExperimentCohort"
},
v16 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeCaseEmbeddedComments"
},
v17 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeCodeSearch"
},
v18 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeDatasourceId"
},
v19 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeFastJiraHydration"
},
v20 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeJiraEmbeddedComments"
},
v21 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeJiraLiteModeFields"
},
v22 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeMercuryAsk"
},
v23 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeNavBoostScore"
},
v24 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeOriginalEntityType"
},
v25 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includePassionfruitAsk"
},
v26 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includePositions"
},
v27 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRisk"
},
v28 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeThirdPartyId"
},
v29 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraFilters"
},
v30 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v31 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "loomFilters"
},
v32 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "matchingLayerExperimentsMetadata"
},
v33 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mercuryFilters"
},
v34 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v35 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryVersion"
},
v36 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchSessionId"
},
v37 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sessionId"
},
v38 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shadowExperimentId"
},
v39 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v40 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceProduct"
},
v41 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceSubProduct"
},
v42 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "talentFilters"
},
v43 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tenantId"
},
v44 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "thirdPartyFilters"
},
v45 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useCaseId"
},
v46 = {
  "kind": "Variable",
  "name": "useCaseId",
  "variableName": "useCaseId"
},
v47 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "queryVersion",
        "variableName": "queryVersion"
      },
      {
        "kind": "Variable",
        "name": "searchSessionId",
        "variableName": "searchSessionId"
      },
      {
        "kind": "Variable",
        "name": "sessionId",
        "variableName": "sessionId"
      },
      {
        "kind": "Variable",
        "name": "sourceProduct",
        "variableName": "sourceProduct"
      },
      {
        "kind": "Variable",
        "name": "sourceSubProduct",
        "variableName": "sourceSubProduct"
      }
    ],
    "kind": "ObjectValue",
    "name": "analytics"
  },
  {
    "kind": "Variable",
    "name": "disableQueryReplacement",
    "variableName": "disableQueryReplacement"
  },
  {
    "kind": "Variable",
    "name": "enableHighlighting",
    "variableName": "enableHighlighting"
  },
  {
    "kind": "Variable",
    "name": "enableRelevanceDebugging",
    "variableName": "enableRelevanceDebugging"
  },
  {
    "kind": "Variable",
    "name": "expectResult",
    "variableName": "expectResult"
  },
  {
    "kind": "Variable",
    "name": "experience",
    "variableName": "experience"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "experimentId",
        "variableName": "experimentId"
      },
      {
        "kind": "Variable",
        "name": "experimentLayers",
        "variableName": "experimentLayers"
      },
      {
        "kind": "Variable",
        "name": "shadowExperimentId",
        "variableName": "shadowExperimentId"
      }
    ],
    "kind": "ObjectValue",
    "name": "experimentContext"
  },
  {
    "kind": "Variable",
    "name": "fanoutExperimentCohort",
    "variableName": "fanoutExperimentCohort"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "assetsFilters",
        "variableName": "assetsFilters"
      },
      {
        "kind": "Variable",
        "name": "commonFilters",
        "variableName": "commonFilters"
      },
      {
        "kind": "Variable",
        "name": "compassFilters",
        "variableName": "compassFilters"
      },
      {
        "kind": "Variable",
        "name": "confluenceFilters",
        "variableName": "confluenceFilters"
      },
      {
        "kind": "Variable",
        "name": "entities",
        "variableName": "entities"
      },
      {
        "kind": "Variable",
        "name": "jiraFilters",
        "variableName": "jiraFilters"
      },
      {
        "kind": "Variable",
        "name": "locations",
        "variableName": "cloudIdARIs"
      },
      {
        "kind": "Variable",
        "name": "loomFilters",
        "variableName": "loomFilters"
      },
      {
        "kind": "Variable",
        "name": "mercuryFilters",
        "variableName": "mercuryFilters"
      },
      {
        "kind": "Variable",
        "name": "talentFilters",
        "variableName": "talentFilters"
      },
      {
        "kind": "Variable",
        "name": "thirdPartyFilters",
        "variableName": "thirdPartyFilters"
      }
    ],
    "kind": "ObjectValue",
    "name": "filters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "limit"
  },
  {
    "kind": "Variable",
    "name": "matchingLayerExperimentsMetadata",
    "variableName": "matchingLayerExperimentsMetadata"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  },
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "sort"
  },
  (v46/*: any*/)
],
v48 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v49 = {
  "kind": "ScalarField",
  "name": "id"
},
v50 = {
  "kind": "ScalarField",
  "name": "description"
},
v51 = {
  "condition": "includeDatasourceId",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "datasourceId"
    }
  ]
},
v52 = {
  "kind": "ScalarField",
  "name": "connectorType"
},
v53 = {
  "kind": "ScalarField",
  "name": "title"
},
v54 = {
  "kind": "ScalarField",
  "name": "url"
},
v55 = {
  "kind": "ScalarField",
  "name": "type"
},
v56 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
},
v57 = {
  "kind": "ScalarField",
  "name": "subtype"
},
v58 = {
  "kind": "ScalarField",
  "name": "integrationId"
},
v59 = {
  "kind": "ScalarField",
  "name": "providerId"
},
v60 = {
  "concreteType": "SearchLinkedResult",
  "kind": "LinkedField",
  "name": "linkedResults",
  "plural": true,
  "selections": [
    (v49/*: any*/),
    (v51/*: any*/),
    {
      "kind": "ScalarField",
      "name": "category"
    },
    (v52/*: any*/),
    (v53/*: any*/),
    (v54/*: any*/),
    (v55/*: any*/),
    (v50/*: any*/),
    (v56/*: any*/),
    (v57/*: any*/),
    (v58/*: any*/),
    (v59/*: any*/)
  ]
},
v61 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isSearchResult"
},
v62 = {
  "kind": "ScalarField",
  "name": "value"
},
v63 = {
  "kind": "ScalarField",
  "name": "label"
},
v64 = [
  (v63/*: any*/)
],
v65 = {
  "kind": "ScalarField",
  "name": "key"
},
v66 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v67 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "TownsquareGoal",
      "kind": "LinkedField",
      "name": "goal",
      "plural": false,
      "selections": [
        {
          "concreteType": "TownsquareStatus",
          "kind": "LinkedField",
          "name": "status",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareLocalizationField",
              "kind": "LinkedField",
              "name": "localizedLabel",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "messageId"
                }
              ]
            },
            (v62/*: any*/),
            {
              "kind": "ScalarField",
              "name": "score"
            }
          ]
        },
        {
          "concreteType": "TownsquareTargetDate",
          "kind": "LinkedField",
          "name": "targetDate",
          "plural": false,
          "selections": (v64/*: any*/)
        },
        (v49/*: any*/),
        (v65/*: any*/),
        (v50/*: any*/)
      ]
    },
    (v66/*: any*/)
  ],
  "type": "SearchResultAtlasGoal"
},
v68 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "TownsquareProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isPrivate"
        },
        {
          "concreteType": "TownsquareTargetDate",
          "kind": "LinkedField",
          "name": "dueDate",
          "plural": false,
          "selections": (v64/*: any*/)
        },
        {
          "concreteType": "TownsquareProjectState",
          "kind": "LinkedField",
          "name": "state",
          "plural": false,
          "selections": [
            (v63/*: any*/),
            (v62/*: any*/)
          ]
        },
        (v49/*: any*/),
        (v65/*: any*/)
      ]
    },
    (v66/*: any*/)
  ],
  "type": "SearchResultAtlasProject"
},
v69 = {
  "kind": "ScalarField",
  "name": "name"
},
v70 = [
  (v69/*: any*/)
],
v71 = {
  "kind": "InlineFragment",
  "selections": [
    (v56/*: any*/),
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        (v48/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "SearchFederatedEmailUser",
              "kind": "LinkedField",
              "name": "sender",
              "plural": false,
              "selections": (v70/*: any*/)
            }
          ],
          "type": "SearchFederatedEmailEntity"
        }
      ]
    }
  ],
  "type": "SearchResultFederated"
},
v72 = {
  "kind": "InlineFragment",
  "selections": [
    (v56/*: any*/),
    {
      "kind": "ScalarField",
      "name": "tier"
    },
    {
      "concreteType": "CompassComponent",
      "kind": "LinkedField",
      "name": "component",
      "plural": false,
      "selections": [
        (v50/*: any*/),
        {
          "kind": "ScalarField",
          "name": "state"
        },
        (v49/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "name": "ownerId"
    }
  ],
  "type": "SearchResultCompassComponent"
},
v73 = {
  "kind": "ScalarField",
  "name": "lastModified"
},
v74 = {
  "kind": "ScalarField",
  "name": "total"
},
v75 = {
  "kind": "ScalarField",
  "name": "count"
},
v76 = [
  (v75/*: any*/)
],
v77 = [
  (v49/*: any*/)
],
v78 = {
  "kind": "InlineFragment",
  "selections": (v77/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v79 = {
  "kind": "ScalarField",
  "name": "picture"
},
v80 = {
  "kind": "ScalarField",
  "name": "email"
},
v81 = [
  {
    "kind": "ScalarField",
    "name": "jobTitle"
  }
],
v82 = {
  "args": [
    {
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "tenantId"
    }
  ],
  "concreteType": "SocialSignalSearch",
  "kind": "LinkedField",
  "name": "socialSignal",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "signal"
    },
    {
      "kind": "ScalarField",
      "name": "timestamp"
    },
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v48/*: any*/),
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        (v69/*: any*/),
        (v79/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v80/*: any*/),
            {
              "concreteType": "AtlassianAccountUserExtendedProfile",
              "kind": "LinkedField",
              "name": "extendedProfile",
              "plural": false,
              "selections": (v81/*: any*/)
            }
          ],
          "type": "AtlassianAccountUser"
        },
        (v49/*: any*/)
      ]
    }
  ]
},
v83 = {
  "kind": "InlineFragment",
  "selections": [
    (v73/*: any*/),
    {
      "kind": "ScalarField",
      "name": "isVerified"
    },
    (v66/*: any*/),
    {
      "concreteType": "SearchConfluenceResultSpace",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v49/*: any*/),
        (v69/*: any*/),
        {
          "kind": "ScalarField",
          "name": "webUiLink"
        }
      ]
    },
    {
      "kind": "LinkedField",
      "name": "confluenceEntity",
      "plural": false,
      "selections": [
        (v48/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v57/*: any*/),
            {
              "concreteType": "ConfluenceCommentCountSummary",
              "kind": "LinkedField",
              "name": "commentCountSummary",
              "plural": false,
              "selections": [
                (v74/*: any*/)
              ]
            },
            {
              "concreteType": "ConfluenceLikesSummary",
              "kind": "LinkedField",
              "name": "likesSummary",
              "plural": false,
              "selections": (v76/*: any*/)
            }
          ],
          "type": "ConfluencePage"
        },
        (v78/*: any*/)
      ]
    },
    (v82/*: any*/),
    {
      "condition": "includeNavBoostScore",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "navBoostScore"
        }
      ]
    }
  ],
  "type": "SearchConfluencePageBlogAttachment"
},
v84 = {
  "kind": "InlineFragment",
  "selections": [
    (v66/*: any*/),
    (v73/*: any*/)
  ],
  "type": "SearchConfluenceSpace"
},
v85 = {
  "kind": "LinkedField",
  "name": "container",
  "plural": false,
  "selections": [
    (v48/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v70/*: any*/),
      "type": "ExternalRepository"
    },
    (v78/*: any*/)
  ]
},
v86 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v87 = {
  "kind": "LinkedField",
  "name": "container",
  "plural": false,
  "selections": [
    (v48/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v86/*: any*/),
        (v54/*: any*/),
        (v57/*: any*/)
      ],
      "type": "ExternalSpace"
    },
    (v78/*: any*/)
  ]
},
v88 = [
  {
    "kind": "ScalarField",
    "name": "reactionType"
  },
  (v74/*: any*/)
],
v89 = {
  "kind": "ScalarField",
  "name": "externalId"
},
v90 = {
  "concreteType": "ThirdPartyUserExtendedProfile",
  "kind": "LinkedField",
  "name": "extendedProfile",
  "plural": false,
  "selections": (v81/*: any*/)
},
v91 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": [
    {
      "concreteType": "ThirdPartyUser",
      "kind": "LinkedField",
      "name": "thirdPartyUser",
      "plural": false,
      "selections": [
        (v69/*: any*/),
        (v80/*: any*/),
        (v79/*: any*/),
        (v89/*: any*/),
        (v90/*: any*/),
        (v49/*: any*/)
      ]
    }
  ]
},
v92 = [
  (v48/*: any*/),
  (v69/*: any*/),
  (v79/*: any*/),
  (v49/*: any*/)
],
v93 = {
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v92/*: any*/)
},
v94 = {
  "kind": "ScalarField",
  "name": "status"
},
v95 = [
  (v86/*: any*/)
],
v96 = {
  "kind": "ScalarField",
  "name": "nickname"
},
v97 = {
  "concreteType": "ExternalAssociationConnection",
  "kind": "LinkedField",
  "name": "associatedWith",
  "plural": false,
  "selections": [
    {
      "concreteType": "ExternalAssociationEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "ExternalAssociation",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "entity",
              "plural": false,
              "selections": [
                (v48/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v89/*: any*/),
                    (v69/*: any*/),
                    (v96/*: any*/),
                    (v80/*: any*/),
                    (v79/*: any*/),
                    (v90/*: any*/),
                    (v49/*: any*/)
                  ],
                  "type": "ThirdPartyUser"
                },
                (v78/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": "channelId",
                      "kind": "ScalarField",
                      "name": "externalId"
                    },
                    (v86/*: any*/)
                  ],
                  "type": "ExternalConversation"
                }
              ]
            },
            (v49/*: any*/)
          ]
        }
      ]
    }
  ]
},
v98 = {
  "kind": "ScalarField",
  "name": "thumbnailUrl"
},
v99 = [
  (v49/*: any*/),
  (v69/*: any*/),
  (v80/*: any*/),
  (v79/*: any*/),
  (v89/*: any*/),
  (v90/*: any*/)
],
v100 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": [
    {
      "concreteType": "ThirdPartyUser",
      "kind": "LinkedField",
      "name": "thirdPartyUser",
      "plural": false,
      "selections": (v99/*: any*/)
    },
    {
      "condition": "__relay_internal__pv__skiplinkeduserhydrationrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseConnection",
          "kind": "LinkedField",
          "name": "linkedUsers",
          "plural": false,
          "selections": [
            {
              "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v48/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v69/*: any*/),
                        (v79/*: any*/),
                        (v49/*: any*/)
                      ],
                      "type": "AtlassianAccountUser"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v77/*: any*/),
                      "type": "AppUser"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v77/*: any*/),
                      "type": "CustomerUser"
                    }
                  ]
                },
                (v49/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
},
v101 = [
  (v49/*: any*/),
  (v69/*: any*/)
],
v102 = {
  "concreteType": "ThirdPartyUser",
  "kind": "LinkedField",
  "name": "thirdPartyUser",
  "plural": false,
  "selections": (v101/*: any*/)
},
v103 = [
  (v102/*: any*/)
],
v104 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "members",
  "plural": true,
  "selections": (v103/*: any*/)
},
v105 = {
  "kind": "ScalarField",
  "name": "memberCount"
},
v106 = {
  "kind": "ScalarField",
  "name": "lastUpdated"
},
v107 = [
  (v69/*: any*/),
  (v49/*: any*/)
],
v108 = {
  "concreteType": "ThirdPartyUser",
  "kind": "LinkedField",
  "name": "thirdPartyUser",
  "plural": false,
  "selections": (v107/*: any*/)
},
v109 = [
  (v108/*: any*/)
],
v110 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "owners",
  "plural": true,
  "selections": (v109/*: any*/)
},
v111 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v109/*: any*/)
},
v112 = [
  (v48/*: any*/),
  (v69/*: any*/),
  (v49/*: any*/)
],
v113 = {
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v112/*: any*/)
},
v114 = [
  (v48/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v49/*: any*/),
      (v86/*: any*/)
    ],
    "type": "ExternalCustomerOrg"
  },
  (v78/*: any*/)
],
v115 = {
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": (v114/*: any*/)
},
v116 = [
  {
    "kind": "ScalarField",
    "name": "lastActivityAt"
  },
  {
    "kind": "ScalarField",
    "name": "event"
  }
],
v117 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "assignee",
  "plural": false,
  "selections": (v103/*: any*/)
},
v118 = {
  "concreteType": "ExternalUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v103/*: any*/)
},
v119 = {
  "kind": "ScalarField",
  "name": "dueDate"
},
v120 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v121 = {
  "kind": "ScalarField",
  "name": "workspaceName"
},
v122 = {
  "kind": "ScalarField",
  "name": "excerpt"
},
v123 = {
  "kind": "ScalarField",
  "name": "eventEndTime"
},
v124 = {
  "kind": "ScalarField",
  "name": "eventStartTime"
},
v125 = {
  "kind": "ScalarField",
  "name": "videoMeetingUrl"
},
v126 = {
  "kind": "ScalarField",
  "name": "parentId"
},
v127 = {
  "concreteType": "ThirdPartyUser",
  "kind": "LinkedField",
  "name": "allContributors",
  "plural": true,
  "selections": [
    (v69/*: any*/),
    (v96/*: any*/),
    (v80/*: any*/),
    (v79/*: any*/),
    (v89/*: any*/),
    (v90/*: any*/),
    (v49/*: any*/)
  ]
},
v128 = {
  "kind": "InlineFragment",
  "selections": [
    (v59/*: any*/),
    (v52/*: any*/),
    (v58/*: any*/),
    (v57/*: any*/),
    (v56/*: any*/),
    {
      "kind": "ScalarField",
      "name": "permissionLevel"
    },
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        (v48/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v69/*: any*/),
            (v85/*: any*/)
          ],
          "type": "ExternalBranch"
        },
        (v78/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v87/*: any*/),
            {
              "concreteType": "ExternalReaction",
              "kind": "LinkedField",
              "name": "reactionsV2",
              "plural": true,
              "selections": (v88/*: any*/)
            },
            (v91/*: any*/)
          ],
          "type": "ExternalComment"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "ExternalUser",
              "kind": "LinkedField",
              "name": "author",
              "plural": false,
              "selections": [
                (v93/*: any*/)
              ]
            },
            (v85/*: any*/)
          ],
          "type": "ExternalCommit"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "LinkedField",
              "name": "container",
              "plural": false,
              "selections": [
                (v48/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v86/*: any*/),
                    (v54/*: any*/)
                  ],
                  "type": "ExternalSpace"
                },
                (v78/*: any*/)
              ]
            },
            {
              "concreteType": "ExternalReaction",
              "kind": "LinkedField",
              "name": "reactions",
              "plural": true,
              "selections": (v88/*: any*/)
            },
            {
              "condition": "includeThirdPartyId",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "thirdPartyId"
                }
              ]
            },
            (v94/*: any*/),
            {
              "concreteType": "ExternalDocumentType",
              "kind": "LinkedField",
              "name": "type",
              "plural": false,
              "selections": [
                (v66/*: any*/)
              ]
            },
            {
              "concreteType": "ExternalLargeContent",
              "kind": "LinkedField",
              "name": "nonIndexableContent",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "mediaThumbnailUrl"
                }
              ]
            },
            {
              "kind": "LinkedField",
              "name": "parent",
              "plural": false,
              "selections": [
                (v48/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v95/*: any*/),
                  "type": "ExternalDocument"
                },
                (v78/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentCount"
            }
          ],
          "type": "ExternalDocument"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v89/*: any*/),
            (v97/*: any*/),
            (v50/*: any*/),
            {
              "concreteType": "ExternalAttachment",
              "kind": "LinkedField",
              "name": "attachments",
              "plural": true,
              "selections": [
                (v53/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "mimeType"
                },
                (v54/*: any*/),
                (v98/*: any*/),
                (v48/*: any*/)
              ]
            },
            (v100/*: any*/),
            {
              "kind": "LinkedField",
              "name": "container",
              "plural": false,
              "selections": [
                (v48/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v86/*: any*/),
                    (v104/*: any*/),
                    (v55/*: any*/),
                    (v49/*: any*/),
                    (v105/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "membershipType"
                    }
                  ],
                  "type": "ExternalConversation"
                },
                (v78/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "lastActive"
            },
            {
              "kind": "ScalarField",
              "name": "reactionCount"
            }
          ],
          "type": "ExternalMessage"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v50/*: any*/),
            (v86/*: any*/),
            (v105/*: any*/),
            {
              "concreteType": "ExternalUser",
              "kind": "LinkedField",
              "name": "members",
              "plural": true,
              "selections": [
                (v48/*: any*/)
              ]
            }
          ],
          "type": "ExternalConversation"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v94/*: any*/),
            {
              "kind": "ScalarField",
              "name": "endDate"
            },
            (v106/*: any*/),
            (v110/*: any*/),
            (v111/*: any*/)
          ],
          "type": "ExternalCampaign"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "displayNumber"
            },
            (v94/*: any*/),
            {
              "kind": "ScalarField",
              "name": "closedAt"
            },
            (v106/*: any*/),
            {
              "concreteType": "ExternalUser",
              "kind": "LinkedField",
              "name": "owners",
              "plural": true,
              "selections": [
                (v108/*: any*/),
                (v113/*: any*/)
              ]
            },
            (v111/*: any*/),
            {
              "kind": "LinkedField",
              "name": "container",
              "plural": false,
              "selections": (v114/*: any*/)
            }
          ],
          "type": "ExternalCase"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v86/*: any*/),
            (v110/*: any*/),
            (v115/*: any*/),
            {
              "concreteType": "ExternalCustomerOrgLastActivity",
              "kind": "LinkedField",
              "name": "customerOrgLastActivity",
              "plural": false,
              "selections": (v116/*: any*/)
            }
          ],
          "type": "ExternalCustomerOrg"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "stage"
            },
            {
              "kind": "ScalarField",
              "name": "dealClosedAt"
            },
            {
              "concreteType": "ExternalDealLastActivity",
              "kind": "LinkedField",
              "name": "lastActivity",
              "plural": false,
              "selections": (v116/*: any*/)
            },
            (v110/*: any*/),
            (v115/*: any*/)
          ],
          "type": "ExternalDeal"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v87/*: any*/),
            (v117/*: any*/),
            (v118/*: any*/),
            (v119/*: any*/),
            (v65/*: any*/),
            (v94/*: any*/)
          ],
          "type": "ExternalProject"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v87/*: any*/),
            (v117/*: any*/),
            (v118/*: any*/),
            (v119/*: any*/),
            (v94/*: any*/),
            (v57/*: any*/),
            {
              "kind": "ScalarField",
              "name": "team"
            },
            {
              "concreteType": "ExternalWorkItemProject",
              "kind": "LinkedField",
              "name": "workItemProject",
              "plural": false,
              "selections": (v101/*: any*/)
            },
            {
              "concreteType": "ExternalProvider",
              "kind": "LinkedField",
              "name": "provider",
              "plural": false,
              "selections": (v70/*: any*/)
            }
          ],
          "type": "ExternalWorkItem"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v53/*: any*/),
            {
              "kind": "ScalarField",
              "name": "lastUpdate"
            },
            {
              "kind": "ScalarField",
              "name": "pullRequestId"
            },
            {
              "alias": "pullRequestStatus",
              "kind": "ScalarField",
              "name": "status"
            },
            (v85/*: any*/)
          ],
          "type": "ExternalPullRequest"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "durationInSeconds"
            },
            {
              "kind": "ScalarField",
              "name": "embedUrl"
            },
            {
              "condition": "__relay_internal__pv__ismetadatacontentenabledrelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "concreteType": "ExternalMetadataContentLink",
                  "kind": "LinkedField",
                  "name": "metadataContentLinks",
                  "plural": true,
                  "selections": [
                    (v54/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "metadataContentUrl"
                }
              ]
            },
            (v98/*: any*/),
            {
              "concreteType": "ExternalEntityExtendedValue",
              "kind": "LinkedField",
              "name": "entityExtendedValues",
              "plural": true,
              "selections": [
                (v120/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "fieldValue"
                },
                {
                  "concreteType": "ExternalEntityExtendedValueDisplayName",
                  "kind": "LinkedField",
                  "name": "fieldDisplayName",
                  "plural": false,
                  "selections": (v95/*: any*/)
                },
                {
                  "kind": "ScalarField",
                  "name": "isDisplayed"
                },
                {
                  "kind": "ScalarField",
                  "name": "dataType"
                }
              ]
            },
            {
              "concreteType": "ExternalChapter",
              "kind": "LinkedField",
              "name": "chapters",
              "plural": true,
              "selections": [
                (v53/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "startTimeInSeconds"
                }
              ]
            },
            {
              "concreteType": "ExternalUser",
              "kind": "LinkedField",
              "name": "createdBy",
              "plural": false,
              "selections": [
                (v102/*: any*/),
                (v113/*: any*/)
              ]
            }
          ],
          "type": "ExternalVideo"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v49/*: any*/),
            (v54/*: any*/),
            (v121/*: any*/),
            (v110/*: any*/)
          ],
          "type": "ExternalDashboard"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v49/*: any*/),
            (v54/*: any*/),
            {
              "alias": "dataTableType",
              "kind": "ScalarField",
              "name": "type"
            },
            (v121/*: any*/),
            (v110/*: any*/)
          ],
          "type": "ExternalDataTable"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "accountName"
            },
            {
              "concreteType": "ExternalUser",
              "kind": "LinkedField",
              "name": "contactUser",
              "plural": false,
              "selections": [
                {
                  "concreteType": "ThirdPartyUser",
                  "kind": "LinkedField",
                  "name": "thirdPartyUser",
                  "plural": false,
                  "selections": [
                    (v69/*: any*/),
                    (v90/*: any*/),
                    (v49/*: any*/)
                  ]
                }
              ]
            }
          ],
          "type": "ExternalCustomerContact"
        }
      ]
    },
    (v122/*: any*/),
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        (v48/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v118/*: any*/),
            (v123/*: any*/),
            (v124/*: any*/),
            {
              "kind": "ScalarField",
              "name": "recurringEventId"
            },
            (v125/*: any*/)
          ],
          "type": "ExternalCalendarEvent"
        },
        (v78/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "ExternalThumbnail",
              "kind": "LinkedField",
              "name": "thumbnail",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "externalUrl"
                }
              ]
            }
          ],
          "type": "ExternalDesign"
        }
      ]
    },
    {
      "concreteType": "SearchResultGraphDocument",
      "kind": "LinkedField",
      "name": "linkedEntities",
      "plural": true,
      "selections": [
        (v49/*: any*/),
        (v53/*: any*/),
        (v54/*: any*/),
        {
          "kind": "LinkedField",
          "name": "entity",
          "plural": false,
          "selections": [
            (v48/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v124/*: any*/),
                (v123/*: any*/),
                (v125/*: any*/)
              ],
              "type": "ExternalCalendarEvent"
            },
            (v78/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v86/*: any*/),
                (v91/*: any*/)
              ],
              "type": "ExternalComment"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v100/*: any*/),
                {
                  "kind": "LinkedField",
                  "name": "container",
                  "plural": false,
                  "selections": [
                    (v48/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v104/*: any*/),
                        (v55/*: any*/)
                      ],
                      "type": "ExternalConversation"
                    },
                    (v78/*: any*/)
                  ]
                },
                (v89/*: any*/),
                (v97/*: any*/),
                (v50/*: any*/)
              ],
              "type": "ExternalMessage"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v50/*: any*/)
              ],
              "type": "ExternalConversation"
            }
          ]
        },
        (v126/*: any*/),
        (v122/*: any*/),
        {
          "concreteType": "ThirdPartyUser",
          "kind": "LinkedField",
          "name": "initialContributors",
          "plural": true,
          "selections": (v99/*: any*/)
        },
        (v58/*: any*/),
        (v127/*: any*/)
      ]
    },
    {
      "concreteType": "ThirdPartyUser",
      "kind": "LinkedField",
      "name": "initialContributors",
      "plural": true,
      "selections": [
        (v69/*: any*/),
        (v79/*: any*/),
        (v49/*: any*/),
        (v80/*: any*/),
        (v89/*: any*/),
        (v90/*: any*/)
      ]
    },
    {
      "concreteType": "SearchResultGraphTab",
      "kind": "LinkedField",
      "name": "tabs",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "tabId"
        },
        (v53/*: any*/),
        (v54/*: any*/),
        (v48/*: any*/)
      ]
    },
    (v121/*: any*/),
    {
      "kind": "ScalarField",
      "name": "createdBy"
    },
    {
      "concreteType": "SearchResultGraphAttachment",
      "kind": "LinkedField",
      "name": "attachments",
      "plural": true,
      "selections": [
        (v53/*: any*/),
        {
          "kind": "ScalarField",
          "name": "fileType"
        },
        (v54/*: any*/),
        (v48/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "name": "containerName"
    },
    {
      "concreteType": "ThirdPartyUser",
      "kind": "LinkedField",
      "name": "allContributors",
      "plural": true,
      "selections": (v101/*: any*/)
    },
    (v127/*: any*/),
    {
      "kind": "ScalarField",
      "name": "links"
    },
    {
      "kind": "ScalarField",
      "name": "linkedEntitiesType"
    },
    {
      "kind": "ScalarField",
      "name": "connectorId"
    },
    {
      "kind": "ScalarField",
      "name": "connectorProduct"
    },
    (v51/*: any*/),
    {
      "condition": "includeOriginalEntityType",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "originalEntityType"
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__isslackworkspacemetadataenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isSharedChannel"
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__isleadnounenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "entity",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v94/*: any*/),
                (v106/*: any*/),
                {
                  "condition": "__relay_internal__pv__isleaduserastitleenabledrelayprovider",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "concreteType": "ExternalUser",
                      "kind": "LinkedField",
                      "name": "leadUser",
                      "plural": false,
                      "selections": (v109/*: any*/)
                    }
                  ]
                },
                (v110/*: any*/),
                (v111/*: any*/)
              ],
              "type": "ExternalLead"
            }
          ]
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__isslacktopreactionenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "SearchSlackReaction",
          "kind": "LinkedField",
          "name": "topReaction",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "emojiName"
            },
            {
              "kind": "ScalarField",
              "name": "emojiUrl"
            },
            (v75/*: any*/)
          ]
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
},
v129 = {
  "condition": "includeCodeSearch",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "path"
        },
        {
          "kind": "ScalarField",
          "name": "language"
        },
        (v56/*: any*/),
        {
          "concreteType": "SearchResultCodeChunk",
          "kind": "LinkedField",
          "name": "matchedChunks",
          "plural": true,
          "selections": [
            (v49/*: any*/),
            {
              "kind": "ScalarField",
              "name": "sourceCode"
            },
            {
              "concreteType": "SearchResultCodeLineRange",
              "kind": "LinkedField",
              "name": "lineRange",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "start"
                }
              ]
            },
            {
              "kind": "ScalarField",
              "name": "matchedRanges"
            }
          ]
        },
        {
          "concreteType": "SearchResultCodeRepository",
          "kind": "LinkedField",
          "name": "repository",
          "plural": false,
          "selections": [
            (v69/*: any*/),
            {
              "kind": "ScalarField",
              "name": "namespace"
            },
            (v54/*: any*/),
            {
              "kind": "ScalarField",
              "name": "scm"
            },
            (v49/*: any*/)
          ]
        }
      ],
      "type": "SearchResultGraphCode"
    }
  ]
},
v130 = {
  "concreteType": "JiraProject",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": (v101/*: any*/)
},
v131 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v132 = [
  (v66/*: any*/),
  (v69/*: any*/),
  (v49/*: any*/)
],
v133 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
],
v134 = [
  {
    "concreteType": "JiraLabelEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraLabel",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": (v70/*: any*/)
      }
    ]
  }
],
v135 = {
  "concreteType": "JiraIssue",
  "kind": "LinkedField",
  "name": "issue",
  "plural": false,
  "selections": [
    {
      "condition": "includeFastJiraHydration",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "issueTypeAvatarUrl"
        },
        {
          "concreteType": "JiraIssueTypeField",
          "kind": "LinkedField",
          "name": "issueTypeField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueType",
              "kind": "LinkedField",
              "name": "issueType",
              "plural": false,
              "selections": (v107/*: any*/)
            },
            (v49/*: any*/)
          ]
        },
        {
          "args": [
            {
              "kind": "Literal",
              "name": "ids",
              "value": [
                "project"
              ]
            }
          ],
          "concreteType": "JiraIssueFieldConnection",
          "kind": "LinkedField",
          "name": "fieldsById",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueFieldEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v48/*: any*/),
                    (v69/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v130/*: any*/)
                      ],
                      "type": "JiraProjectField"
                    },
                    (v49/*: any*/)
                  ]
                }
              ]
            }
          ],
          "storageKey": "fieldsById(ids:[\"project\"])"
        },
        {
          "concreteType": "JiraSingleSelectUserPickerField",
          "kind": "LinkedField",
          "name": "assigneeField",
          "plural": false,
          "selections": [
            (v93/*: any*/),
            (v49/*: any*/)
          ]
        }
      ]
    },
    (v131/*: any*/),
    (v65/*: any*/),
    {
      "condition": "includeFastJiraHydration",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraIssueType",
          "kind": "LinkedField",
          "name": "issueType",
          "plural": false,
          "selections": [
            (v69/*: any*/),
            {
              "concreteType": "JiraAvatar",
              "kind": "LinkedField",
              "name": "avatar",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "medium"
                }
              ]
            },
            (v49/*: any*/)
          ]
        },
        (v130/*: any*/),
        {
          "kind": "LinkedField",
          "name": "assignee",
          "plural": false,
          "selections": (v92/*: any*/)
        },
        {
          "condition": "includeJiraLiteModeFields",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "fastPriority",
              "concreteType": "JiraPriority",
              "kind": "LinkedField",
              "name": "priority",
              "plural": false,
              "selections": (v132/*: any*/)
            },
            {
              "alias": "fastLabels",
              "args": (v133/*: any*/),
              "concreteType": "JiraLabelConnection",
              "kind": "LinkedField",
              "name": "labels",
              "plural": false,
              "selections": (v134/*: any*/),
              "storageKey": "labels(first:5)"
            }
          ]
        }
      ]
    },
    {
      "condition": "includeJiraLiteModeFields",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "condition": "includeFastJiraHydration",
          "kind": "Condition",
          "passingValue": false,
          "selections": [
            {
              "concreteType": "JiraPriorityField",
              "kind": "LinkedField",
              "name": "priorityField",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraPriority",
                  "kind": "LinkedField",
                  "name": "priority",
                  "plural": false,
                  "selections": (v132/*: any*/)
                },
                (v49/*: any*/)
              ]
            },
            {
              "concreteType": "JiraLabelsField",
              "kind": "LinkedField",
              "name": "labelsField",
              "plural": false,
              "selections": [
                {
                  "args": (v133/*: any*/),
                  "concreteType": "JiraLabelConnection",
                  "kind": "LinkedField",
                  "name": "selectedLabelsConnection",
                  "plural": false,
                  "selections": (v134/*: any*/),
                  "storageKey": "selectedLabelsConnection(first:5)"
                },
                (v49/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v49/*: any*/)
  ]
},
v136 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "projectKey"
    },
    (v56/*: any*/),
    (v66/*: any*/),
    {
      "concreteType": "JiraProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v131/*: any*/),
        {
          "condition": "includeJiraLiteModeFields",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "lead",
              "plural": false,
              "selections": (v92/*: any*/)
            },
            {
              "concreteType": "JiraAvatar",
              "kind": "LinkedField",
              "name": "avatar",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "small"
                }
              ]
            },
            {
              "kind": "ScalarField",
              "name": "projectStyle"
            },
            {
              "kind": "ScalarField",
              "name": "projectType"
            },
            {
              "concreteType": "JiraProjectCategory",
              "kind": "LinkedField",
              "name": "category",
              "plural": false,
              "selections": (v107/*: any*/)
            }
          ]
        },
        (v49/*: any*/)
      ]
    },
    (v82/*: any*/)
  ],
  "type": "SearchResultJiraProject"
},
v137 = [
  (v56/*: any*/),
  (v66/*: any*/)
],
v138 = {
  "kind": "InlineFragment",
  "selections": (v137/*: any*/),
  "type": "SearchResultJiraPlan"
},
v139 = {
  "kind": "InlineFragment",
  "selections": [
    (v56/*: any*/),
    (v66/*: any*/),
    {
      "concreteType": "JiraBoard",
      "kind": "LinkedField",
      "name": "board",
      "plural": false,
      "selections": [
        (v66/*: any*/),
        {
          "kind": "ScalarField",
          "name": "boardFrontendUrl"
        },
        (v49/*: any*/)
      ]
    }
  ],
  "type": "SearchResultJiraBoard"
},
v140 = {
  "kind": "InlineFragment",
  "selections": (v137/*: any*/),
  "type": "SearchResultJiraDashboard"
},
v141 = {
  "kind": "InlineFragment",
  "selections": (v137/*: any*/),
  "type": "SearchResultJiraFilter"
},
v142 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "totalNestedVideos"
    }
  ],
  "type": "SearchResultLoomFolder"
},
v143 = {
  "kind": "ScalarField",
  "name": "creatorName"
},
v144 = {
  "kind": "InlineFragment",
  "selections": [
    (v143/*: any*/)
  ],
  "type": "SearchResultLoomPlaylist"
},
v145 = {
  "kind": "InlineFragment",
  "selections": (v76/*: any*/),
  "type": "SearchResultLoomTag"
},
v146 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "durationSeconds"
    },
    (v143/*: any*/)
  ],
  "type": "SearchResultLoomVideo"
},
v147 = [
  (v65/*: any*/),
  (v86/*: any*/),
  (v49/*: any*/)
],
v148 = [
  {
    "kind": "ScalarField",
    "name": "targetDate"
  },
  {
    "kind": "ScalarField",
    "name": "targetDateType"
  }
],
v149 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "MercuryFocusArea",
      "kind": "LinkedField",
      "name": "focusArea",
      "plural": false,
      "selections": [
        {
          "concreteType": "MercuryFocusAreaStatus",
          "kind": "LinkedField",
          "name": "status",
          "plural": false,
          "selections": (v147/*: any*/)
        },
        {
          "concreteType": "MercuryFocusAreaHealth",
          "kind": "LinkedField",
          "name": "health",
          "plural": false,
          "selections": [
            (v65/*: any*/),
            {
              "kind": "ScalarField",
              "name": "color"
            },
            (v86/*: any*/),
            (v49/*: any*/)
          ]
        },
        {
          "concreteType": "MercuryTargetDate",
          "kind": "LinkedField",
          "name": "targetDate",
          "plural": false,
          "selections": (v148/*: any*/)
        },
        (v49/*: any*/),
        (v69/*: any*/),
        {
          "concreteType": "MercuryFocusAreaType",
          "kind": "LinkedField",
          "name": "focusAreaType",
          "plural": false,
          "selections": (v101/*: any*/)
        },
        {
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": (v112/*: any*/)
        }
      ]
    },
    (v56/*: any*/)
  ],
  "type": "SearchResultMercuryFocusArea"
},
v150 = {
  "kind": "InlineFragment",
  "selections": [
    (v56/*: any*/),
    {
      "concreteType": "MercuryFocusArea",
      "kind": "LinkedField",
      "name": "focusArea",
      "plural": false,
      "selections": (v107/*: any*/)
    }
  ],
  "type": "SearchResultMercuryFocusAreaStatusUpdate"
},
v151 = {
  "condition": "includeRisk",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v56/*: any*/),
        {
          "concreteType": "MercuryRisk",
          "kind": "LinkedField",
          "name": "risk",
          "plural": false,
          "selections": [
            {
              "concreteType": "MercuryRiskStatus",
              "kind": "LinkedField",
              "name": "status",
              "plural": false,
              "selections": (v147/*: any*/)
            },
            {
              "concreteType": "MercuryRiskTargetDate",
              "kind": "LinkedField",
              "name": "targetDate",
              "plural": false,
              "selections": (v148/*: any*/)
            },
            (v49/*: any*/)
          ]
        }
      ],
      "type": "SearchResultMercuryRisk"
    }
  ]
},
v152 = {
  "condition": "includeMercuryAsk",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v56/*: any*/),
        {
          "alias": "mercuryAsk",
          "concreteType": "MercuryAsk",
          "kind": "LinkedField",
          "name": "ask",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "askStatus"
            },
            {
              "concreteType": "MercuryAskTargetDate",
              "kind": "LinkedField",
              "name": "targetDate",
              "plural": false,
              "selections": (v148/*: any*/)
            },
            (v49/*: any*/)
          ]
        }
      ],
      "type": "SearchResultMercuryAsk"
    }
  ]
},
v153 = {
  "condition": "includePassionfruitAsk",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "SpfAsk",
          "kind": "LinkedField",
          "name": "ask",
          "plural": false,
          "selections": [
            (v94/*: any*/),
            {
              "concreteType": "SpfAskTargetDate",
              "kind": "LinkedField",
              "name": "targetDate",
              "plural": false,
              "selections": (v148/*: any*/)
            },
            (v49/*: any*/)
          ]
        },
        (v56/*: any*/)
      ],
      "type": "SearchResultSpfAsk"
    }
  ]
},
v154 = [
  (v56/*: any*/)
],
v155 = {
  "kind": "InlineFragment",
  "selections": (v154/*: any*/),
  "type": "SearchResultTrelloBoard"
},
v156 = {
  "kind": "InlineFragment",
  "selections": (v154/*: any*/),
  "type": "SearchResultTrelloCard"
},
v157 = {
  "concreteType": "AssetsLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "web"
    }
  ]
},
v158 = {
  "concreteType": "AssetsSchema",
  "kind": "LinkedField",
  "name": "objectSchemaEntity",
  "plural": false,
  "selections": [
    (v69/*: any*/),
    (v86/*: any*/),
    (v49/*: any*/)
  ]
},
v159 = [
  {
    "kind": "ScalarField",
    "name": "url48"
  }
],
v160 = {
  "condition": "__relay_internal__pv__isassetsenabledrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v56/*: any*/),
        {
          "concreteType": "AssetsSchema",
          "kind": "LinkedField",
          "name": "objectSchemaEntity",
          "plural": false,
          "selections": [
            (v69/*: any*/),
            (v86/*: any*/),
            (v157/*: any*/),
            (v49/*: any*/)
          ]
        }
      ],
      "type": "SearchResultAssetsObjectSchema"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v56/*: any*/),
        (v158/*: any*/),
        {
          "concreteType": "AssetsObjectType",
          "kind": "LinkedField",
          "name": "objectTypeEntity",
          "plural": false,
          "selections": [
            (v69/*: any*/),
            (v86/*: any*/),
            {
              "concreteType": "AssetsIcon",
              "kind": "LinkedField",
              "name": "icon",
              "plural": false,
              "selections": (v159/*: any*/)
            },
            (v157/*: any*/),
            (v49/*: any*/)
          ]
        }
      ],
      "type": "SearchResultAssetsObjectType"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v56/*: any*/),
        (v158/*: any*/),
        {
          "concreteType": "AssetsObject",
          "kind": "LinkedField",
          "name": "objectEntity",
          "plural": false,
          "selections": [
            {
              "concreteType": "AssetsAvatar",
              "kind": "LinkedField",
              "name": "avatar",
              "plural": false,
              "selections": (v159/*: any*/)
            },
            (v157/*: any*/),
            (v49/*: any*/)
          ]
        }
      ],
      "type": "SearchResultAssetsObject"
    }
  ]
},
v161 = [
  (v65/*: any*/),
  (v49/*: any*/)
],
v162 = {
  "condition": "includePositions",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "RadarPosition",
          "kind": "LinkedField",
          "name": "position",
          "plural": false,
          "selections": [
            (v48/*: any*/),
            {
              "concreteType": "RadarWorker",
              "kind": "LinkedField",
              "name": "worker",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "preferredName"
                },
                {
                  "kind": "LinkedField",
                  "name": "user",
                  "plural": false,
                  "selections": [
                    (v48/*: any*/),
                    (v79/*: any*/),
                    (v49/*: any*/)
                  ]
                },
                (v49/*: any*/)
              ]
            },
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "fieldIdIsIn",
                  "value": [
                    "positionId",
                    "positionStatus",
                    "positionJobTitle",
                    "positionPositionTitle",
                    "positionKey",
                    "positionExternalPositionKey",
                    "positionWorker",
                    "focusArea"
                  ]
                }
              ],
              "concreteType": "RadarFieldValueIdPair",
              "kind": "LinkedField",
              "name": "fieldValues",
              "plural": true,
              "selections": [
                (v120/*: any*/),
                {
                  "kind": "LinkedField",
                  "name": "fieldValue",
                  "plural": false,
                  "selections": [
                    (v48/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": "stringValue",
                          "kind": "ScalarField",
                          "name": "value"
                        }
                      ],
                      "type": "RadarStringFieldValue"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "value",
                          "plural": false,
                          "selections": [
                            (v48/*: any*/),
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                (v69/*: any*/),
                                {
                                  "concreteType": "MercuryFocusAreaStatus",
                                  "kind": "LinkedField",
                                  "name": "status",
                                  "plural": false,
                                  "selections": (v161/*: any*/)
                                },
                                {
                                  "concreteType": "MercuryFocusAreaHealth",
                                  "kind": "LinkedField",
                                  "name": "health",
                                  "plural": false,
                                  "selections": (v161/*: any*/)
                                }
                              ],
                              "type": "MercuryFocusArea"
                            },
                            (v78/*: any*/)
                          ]
                        }
                      ],
                      "type": "RadarAriFieldValue"
                    }
                  ]
                }
              ],
              "storageKey": "fieldValues(fieldIdIsIn:[\"positionId\",\"positionStatus\",\"positionJobTitle\",\"positionPositionTitle\",\"positionKey\",\"positionExternalPositionKey\",\"positionWorker\",\"focusArea\"])"
            },
            (v49/*: any*/)
          ]
        }
      ],
      "type": "SearchResultTalentPosition"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v34/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/),
      (v37/*: any*/),
      (v38/*: any*/),
      (v39/*: any*/),
      (v40/*: any*/),
      (v41/*: any*/),
      (v42/*: any*/),
      (v43/*: any*/),
      (v44/*: any*/),
      (v45/*: any*/)
    ],
    "kind": "Fragment",
    "name": "searchResultsAsyncQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "deferFederatedResults",
            "variableName": "deferFederatedResults"
          },
          {
            "kind": "Variable",
            "name": "includeCaseEmbeddedComments",
            "variableName": "includeCaseEmbeddedComments"
          },
          {
            "kind": "Variable",
            "name": "includeCodeSearch",
            "variableName": "includeCodeSearch"
          },
          {
            "kind": "Variable",
            "name": "includeDatasourceId",
            "variableName": "includeDatasourceId"
          },
          {
            "kind": "Variable",
            "name": "includeFastJiraHydration",
            "variableName": "includeFastJiraHydration"
          },
          {
            "kind": "Variable",
            "name": "includeJiraEmbeddedComments",
            "variableName": "includeJiraEmbeddedComments"
          },
          {
            "kind": "Variable",
            "name": "includeJiraLiteModeFields",
            "variableName": "includeJiraLiteModeFields"
          },
          {
            "kind": "Variable",
            "name": "includeMercuryAsk",
            "variableName": "includeMercuryAsk"
          },
          {
            "kind": "Variable",
            "name": "includeNavBoostScore",
            "variableName": "includeNavBoostScore"
          },
          {
            "kind": "Variable",
            "name": "includeOriginalEntityType",
            "variableName": "includeOriginalEntityType"
          },
          {
            "kind": "Variable",
            "name": "includePassionfruitAsk",
            "variableName": "includePassionfruitAsk"
          },
          {
            "kind": "Variable",
            "name": "includePositions",
            "variableName": "includePositions"
          },
          {
            "kind": "Variable",
            "name": "includeRisk",
            "variableName": "includeRisk"
          },
          {
            "kind": "Variable",
            "name": "includeThirdPartyId",
            "variableName": "includeThirdPartyId"
          },
          (v46/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "searchResults_AtlassianSearchPage_SearchResultsAsyncInner_queryData"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v34/*: any*/),
      (v2/*: any*/),
      (v43/*: any*/),
      (v30/*: any*/),
      (v10/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/),
      (v37/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v29/*: any*/),
      (v31/*: any*/),
      (v1/*: any*/),
      (v33/*: any*/),
      (v42/*: any*/),
      (v4/*: any*/),
      (v44/*: any*/),
      (v39/*: any*/),
      (v40/*: any*/),
      (v41/*: any*/),
      (v13/*: any*/),
      (v38/*: any*/),
      (v14/*: any*/),
      (v32/*: any*/),
      (v0/*: any*/),
      (v7/*: any*/),
      (v12/*: any*/),
      (v45/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v15/*: any*/),
      (v11/*: any*/),
      (v26/*: any*/),
      (v28/*: any*/),
      (v18/*: any*/),
      (v24/*: any*/),
      (v23/*: any*/),
      (v25/*: any*/),
      (v27/*: any*/),
      (v22/*: any*/),
      (v21/*: any*/),
      (v19/*: any*/),
      (v17/*: any*/),
      (v16/*: any*/),
      (v6/*: any*/),
      (v20/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__isassetsenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__isslackworkspacemetadataenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__isleadnounenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__isleaduserastitleenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__isslacktopreactionenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__skiplinkeduserhydrationrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__isprojectrendererenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__ismetadatacontentenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "searchResultsAsyncQuery",
    "selections": [
      {
        "concreteType": "SearchQueryAPI",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": [
          {
            "alias": "search",
            "args": (v47/*: any*/),
            "concreteType": "SearchItemConnection",
            "kind": "LinkedField",
            "name": "asyncSearch",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isCachedResult"
              },
              {
                "concreteType": "SearchResultItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v48/*: any*/),
                      (v49/*: any*/),
                      (v50/*: any*/),
                      (v60/*: any*/),
                      (v61/*: any*/),
                      (v53/*: any*/),
                      (v55/*: any*/),
                      (v54/*: any*/),
                      (v67/*: any*/),
                      (v68/*: any*/),
                      (v71/*: any*/),
                      (v72/*: any*/),
                      (v83/*: any*/),
                      (v84/*: any*/),
                      (v128/*: any*/),
                      (v129/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v56/*: any*/),
                          (v66/*: any*/),
                          (v135/*: any*/),
                          {
                            "condition": "includeJiraEmbeddedComments",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "SearchResultJiraComment",
                                "kind": "LinkedField",
                                "name": "comments",
                                "plural": true,
                                "selections": [
                                  (v49/*: any*/),
                                  (v126/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "body"
                                  },
                                  (v54/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "authorUser",
                                    "plural": false,
                                    "selections": (v92/*: any*/)
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "type": "SearchResultJiraIssue"
                      },
                      (v136/*: any*/),
                      (v138/*: any*/),
                      (v139/*: any*/),
                      (v140/*: any*/),
                      (v141/*: any*/),
                      (v142/*: any*/),
                      (v144/*: any*/),
                      (v145/*: any*/),
                      (v146/*: any*/),
                      (v149/*: any*/),
                      (v150/*: any*/),
                      (v151/*: any*/),
                      (v152/*: any*/),
                      (v153/*: any*/),
                      (v155/*: any*/),
                      (v156/*: any*/),
                      (v160/*: any*/),
                      (v162/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "SearchQueryInfo",
                "kind": "LinkedField",
                "name": "queryInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "originalQuery"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "replacementQuery"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "suggestedQuery"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "originalQueryType"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "confidenceScore"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "shouldTriggerAutocorrectionExperience"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "traceId"
              },
              {
                "concreteType": "SearchError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "statusCode"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "product"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "integration"
                  }
                ]
              },
              {
                "condition": "deferFederatedResults",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "if": "deferFederatedResults",
                    "kind": "Defer",
                    "label": "searchResults_AtlassianSearchPage_SearchResultsBody_connectionData$defer$searchResultsAsyncQuery_federatedEdges",
                    "selections": [
                      {
                        "concreteType": "SearchResultItemEdge",
                        "kind": "LinkedField",
                        "name": "federatedEdges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v48/*: any*/),
                              (v49/*: any*/),
                              (v50/*: any*/),
                              (v60/*: any*/),
                              (v61/*: any*/),
                              (v53/*: any*/),
                              (v55/*: any*/),
                              (v54/*: any*/),
                              (v67/*: any*/),
                              (v68/*: any*/),
                              (v71/*: any*/),
                              (v72/*: any*/),
                              (v83/*: any*/),
                              (v84/*: any*/),
                              (v128/*: any*/),
                              (v129/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v56/*: any*/),
                                  (v66/*: any*/),
                                  (v135/*: any*/)
                                ],
                                "type": "SearchResultJiraIssue"
                              },
                              (v136/*: any*/),
                              (v138/*: any*/),
                              (v139/*: any*/),
                              (v140/*: any*/),
                              (v141/*: any*/),
                              (v142/*: any*/),
                              (v144/*: any*/),
                              (v145/*: any*/),
                              (v146/*: any*/),
                              (v149/*: any*/),
                              (v150/*: any*/),
                              (v151/*: any*/),
                              (v152/*: any*/),
                              (v153/*: any*/),
                              (v155/*: any*/),
                              (v156/*: any*/),
                              (v160/*: any*/),
                              (v162/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "alias": "search",
            "args": (v47/*: any*/),
            "filters": [
              "experience",
              "useCaseId",
              "enableHighlighting",
              "enableRelevanceDebugging",
              "query",
              "sort",
              "disableQueryReplacement",
              "fanoutExperimentCohort",
              "expectResult",
              "filters",
              "analytics",
              "experimentContext",
              "matchingLayerExperimentsMetadata"
            ],
            "handle": "connection",
            "key": "SearchResultsAsyncPagination__search",
            "kind": "LinkedHandle",
            "name": "asyncSearch"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c26a0822e9d917157513144d6dd817c0be149e4fa8a793cdc98cf8b0bbc52500",
    "metadata": {},
    "name": "searchResultsAsyncQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__isassetsenabledrelayprovider": includeAssets_provider,
      "__relay_internal__pv__isslackworkspacemetadataenabledrelayprovider": includeSlackWorkspaceMetadata_provider,
      "__relay_internal__pv__isleadnounenabledrelayprovider": isLeadNounEnabled_provider,
      "__relay_internal__pv__isleaduserastitleenabledrelayprovider": isLeadUserAsTitleEnabled_provider,
      "__relay_internal__pv__isslacktopreactionenabledrelayprovider": includeSlackTopReaction_provider,
      "__relay_internal__pv__skiplinkeduserhydrationrelayprovider": skipLinkedUserHydration_provider,
      "__relay_internal__pv__isprojectrendererenabledrelayprovider": isProjectRendererEnabled_provider,
      "__relay_internal__pv__ismetadatacontentenabledrelayprovider": includeMetadataContent_provider
    }
  }
};
})();

(node as any).hash = "c20a83d58979e4dd0c6b09f9420b4012";

export default node;
